require('./angular-cookies');
module.exports = 'ngCookies';



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular-cookies/index.js
 ** module id = 199
 ** module chunks = 0
 **/